import { IList } from 'annotation-tools/utils';
import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { MuiButton, MuiInput } from '../shared/form-element';

const Root = styled.div`
  height: 100%;
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const InputWrapper = styled.div`
  padding: 5px;
`;

const ButtonWrapper = styled.div`
  padding: 5px;
`;

interface Props {
  email: string;
  setEmail: (v: string) => void;
  emailErrors: IList<string>;
  password: string;
  setPassword: (v: string) => void;
  passwordErrors: IList<string>;
  nonFieldErrors: IList<string>;
  detailErrors: string;
  loginButtonIsClickable: boolean;
  loginOnClick: () => void;
}

export const LoginMainView: FC<Props> = memo(
  ({
    email,
    setEmail,
    emailErrors,
    password,
    setPassword,
    passwordErrors,
    nonFieldErrors,
    detailErrors,
    loginButtonIsClickable,
    loginOnClick
  }: Readonly<Props>) => (
    <Root>
      <Content>
        <InputWrapper>
          <MuiInput
            type='email'
            label='E-mail'
            value={email}
            onChange={setEmail}
            helperText={emailErrors.join('\n')}
          />
        </InputWrapper>
        <InputWrapper>
          <MuiInput
            type='password'
            label='Password'
            value={password}
            onChange={setPassword}
            helperText={passwordErrors.join('\n')}
          />
        </InputWrapper>
        {nonFieldErrors.map(err => (
          <div key={err}>{err}</div>
        ))}
        <div>{detailErrors}</div>
        <ButtonWrapper>
          {!loginButtonIsClickable ? (
            <MuiButton disabled={true} label='Login' />
          ) : (
            <MuiButton label='Login' onClick={loginOnClick} />
          )}
        </ButtonWrapper>
      </Content>
    </Root>
  )
);

LoginMainView.displayName = 'LoginMainView';
